export enum ErrorFileMessageMap {
    "The file size exceeds the maximum allowed" = "El tamaño del archivo excede el máximo permitido",
    "Uploaded file must be a '.xls', '.xlsx', 'csv' or 'txt' file." = "El archivo importado debe cumplir con los siguientes formatos CSV, XLSX, XLS y TXT",
    "Allowed number of files" = "Solo se permite un archivo por proceso",
    "DEFAULT" = "Hubo un error. Intentelo nuevamente"
}

export enum ErrorFileMessageBatchMap {
  "The file size exceeds the maximum allowed" = "El tamaño del archivo excede el máximo permitido",
  "Uploaded file must be a '.xls', '.xlsx', or '.csv' file." = "El archivo importado debe cumplir con los siguientes formatos CSV, XLSX y XLS",
  "Allowed number of files" = "Solo se permite un archivo por proceso",
  "DEFAULT" = "Hubo un error. Intentelo nuevamente"
}

